exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selects[data-v-af7788d4]{width:100%;margin-bottom:18px;display:-ms-grid;display:grid;row-gap:9px}@media only screen and (min-width:620px){.selects[data-v-af7788d4]{width:auto;margin-bottom:0;-ms-grid-columns:110px 70px;grid-template-columns:110px 70px;column-gap:20px;row-gap:0}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af7788d4","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterselect/FilterSelectBlock.vue
// module id = d93830768f085c4fb6fb
// module chunks = 7